module.exports = __webpack_public_path__ + "img/2.0c38cd64.png";